import { useEffect } from 'react'

import btcIcon from '@Static/images/currencies/btc.png'
import cn from 'clsx'
import { format, isToday, isYesterday, parse } from 'date-fns'
import { useDispatch } from 'react-redux'

import { getValueWithCurrency } from '@App/helpers/toCurrency'
import { useAppSelector } from '@App/hooks'
import { addSuccessNotify } from '@App/redux/slices/notifications/NotificationSlice'
import { asyncGetTransactions, Transaction } from '@App/redux/slices/reports/ReportsSlice'
import { allTransactions } from '@App/redux/slices/reports/selectors'
import { currentWallet } from '@App/redux/slices/user/selectors'
import { ToolTip } from '@App/ui/crypto_exchange/desktop/components/controls/ToolTip'

import s from './styles.module.scss'
import { formatDate, formatTime, useCopyText } from '../../model'
import { MarketIcon } from '@App/ui/crypto_exchange/desktop/components/common/MarketIcon'

export const TransactionsTable = ({ onRowClick }: { onRowClick?: (val: Transaction) => void }) => {
  const transactions = useAppSelector(allTransactions)
  const wallet = useAppSelector(currentWallet)
  const dispatch = useDispatch()
  const columns: { title: string; width: string }[] = [
    { title: 'Date', width: '2%' },
    { title: 'Time', width: '2%' },
    { title: 'Type', width: '10%' },
    { title: 'Info', width: '9%' },
    { title: 'Status', width: '15%' },
    { title: 'Result', width: '8%' },
    { title: 'Balance', width: '3%' },
    { title: 'ID', width: '1%' },
  ]

  useEffect(() => {
    dispatch(asyncGetTransactions(null))
  }, [])

  const { copyText } = useCopyText()

  return (
    <div className={s.tableContainer}>
      <table className={s.table}>
        <thead>
          <tr>
            {columns.map((col) => (
              <th style={{ width: col.width }} key={col.title} className={s[col.title.toLocaleLowerCase()]}>
                {col.title}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {transactions.map((transaction) => (
            <tr className={s.row} key={transaction.id} onClick={() => onRowClick?.(transaction)}>
              <td className={s.col}>{formatDate(transaction.transaction_time)}</td>
              <td className={s.col}>{formatTime(transaction.transaction_time)}</td>
              <td className={s.col}>{transaction.type}</td>
              <td className={cn(s.col, s.info)}>
                <MarketIcon className={s.icon} source_currency="BTC" target_currency="EUR" /> BTC/EUR
              </td>
              <td className={s.col}>Processed</td>
              <td className={cn(s.col, s.result, transaction.source.amount.amount < 0 && s.negative)}>
                {transaction.source.amount.currency_symbol}
                <span> {transaction.source.amount.amount}</span>
              </td>

              <td className={s.col}>
                {wallet?.currency_code && getValueWithCurrency(wallet?.currency_code, wallet?.amount)}
              </td>
              <td className={s.col}>
                <ToolTip content={<span className={s.toolTip}>{transaction.front_id}</span>}>
                  <span className={s.idBadge} onClick={() => copyText(transaction.front_id)}>
                    ID
                  </span>
                </ToolTip>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
